import { fromJS } from 'immutable';
import I18n from 'I18n';
import { COLUMN, TABLE, FUNNEL, SANKEY } from 'reporting-data/constants/chartTypes';
import { getReferenceLabel } from 'reporting-data/v2/dataset/datasetTypes';
import { FIELDS } from '../../constants/fields';
import { generateDrilldownMeasure } from './drilldownMeasure';
import { FILTERED_ENTITIES } from '../../constants/fields';
const pointBasedEventHandler = ({
  point
}) => {
  const row = point.get('row').toJS();
  return {
    row
  };
};
const rowBasedEventHandler = ({
  row: immutableRow
}) => {
  const row = immutableRow.toJS();
  return {
    row
  };
};
export const eventHandlers = {
  [COLUMN]: pointBasedEventHandler,
  [FUNNEL]: rowBasedEventHandler,
  [TABLE]: rowBasedEventHandler,
  [SANKEY]: pointBasedEventHandler
};
export const generateDrilldownReport = (report, datamap, row, selectedField) => {
  const name = row.from ? I18n.text('reporting-snowflake.funnel.drilldown-name', {
    from: getReferenceLabel(datamap['primary'], FIELDS.FROM, row.from),
    to: getReferenceLabel(datamap['primary'], FIELDS.TO, row.to)
  }) : getReferenceLabel(datamap['primary'], FIELDS.TO, row.to);
  return {
    journeyQuery: Object.assign({}, report.journeyQuery, {
      measure: generateDrilldownMeasure(row, selectedField)
    }),
    chartType: TABLE,
    name
  };
};
export const createDrilldownGenerator = (report, datamap, onDrilldown) => {
  return onDrilldown ? event => {
    const {
      field: selectedField
    } = event;
    const {
      row
    } = eventHandlers[report.chartType](event);
    // TODO: remove the following conditional return if/when the 'filtered entities' stage is
    // removed from sankey visualizations (https://git.hubteam.com/HubSpot/journeys-ui/issues/270)
    if (row.to === FILTERED_ENTITIES) return undefined;
    const drilldownReport = generateDrilldownReport(report, datamap, row, selectedField);
    return onDrilldown(fromJS(drilldownReport));
  } : undefined;
};